import { Text } from '@chakra-ui/react';
import { formatDate } from '@utils/date.utils';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';

import { DateTimeEnum } from '@/types/dateTime.types';

type NotificationDatesRangeProps = {
  startTime: string;
  endTime: string | null;
};

export function NotificationDatesRange({ startTime, endTime }: Readonly<NotificationDatesRangeProps>) {
  const formattedStartDate = formatDate(startTime, DateTimeEnum.DATE);
  const formattedEndDate = endTime && formatDate(endTime, DateTimeEnum.DATE);
  const formattedStartTime = format(new Date(startTime), "HH':'mm':'ss");
  const formattedEndTime = endTime && format(new Date(endTime), "HH':'mm':'ss");

  const endedSameDay = formattedStartDate === formattedEndDate;
  const endedLabelKey = endedSameDay ? 'endedSameDay' : 'endedMultipleDays';

  return (
    <Text color="neutral.300" whiteSpace="pre-line">
      <FormattedMessage
        id={`notification.dates.${endTime ? endedLabelKey : 'onGoing'}`}
        values={{
          startDate: (
            <Text as="span" key="formattedStartDate" color="neutral.white">
              {formattedStartDate}
            </Text>
          ),
          startTime: (
            <Text as="span" key="formattedStartTime" color="neutral.white">
              {formattedStartTime}
            </Text>
          ),
          endDate: (
            <Text as="span" key="formattedEndDate" color="neutral.white">
              {formattedEndDate}
            </Text>
          ),
          endTime: (
            <Text as="span" key="formattedEndTime" color="neutral.white">
              {formattedEndTime}
            </Text>
          ),
        }}
      />
    </Text>
  );
}
